const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4af17c8a98f759300895a931a664f9596a3cc3d6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@everyonesocial"]={id:"4af17c8a98f759300895a931a664f9596a3cc3d6"};
      